const e = {
  serverInfo: {
    schema: {
      method: "get",
      url: "/server/info"
    }
  },
  ping: {
    schema: {
      method: "get",
      url: "/server/ping"
    }
  }
};
export {
  e as serverService
};
